/**
 * Wrapper-type compatibility between a product and a follow-up's SOURCE
 * account (QL-283 decision 19). The account is the sole basis: "can the
 * source account hold this product?"
 *
 *  - a product with NO wrapper preferences fits any account;
 *  - an account with NO wrapper type (null — typical for purely
 *    bank-originated accounts) is unsegregated and takes every product;
 *  - otherwise the account's wrapper must be one of the product's
 *    `wrapperSyncKeys`.
 *
 * One definition for every surface — the account-creation engine, order
 * routing, the switch-pair service and the builder's picker/badges all
 * answer this question and must stay in lockstep.
 */
export function isWrapperCompatibleWithSourceAccount(
  wrapperSyncKeys: readonly string[] | null | undefined,
  sourceAccountWrapperType: string | null,
): boolean {
  const keys = wrapperSyncKeys ?? [];
  if (keys.length === 0) return true;
  if (sourceAccountWrapperType === null) return true;
  return keys.includes(sourceAccountWrapperType);
}
